import React, { lazy } from 'react';
import { Check, Sparkles, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = [<>
    Generar ingresos <strong className="text-[#D98BAF]" data-id="element-364">REALES</strong> desde
    casa{' '}
    <em className="not-italic text-white/50 text-sm block mt-1" data-id="element-365">
      (sin experiencia previa)
    </em>
  </>, <>
    Ser más <strong className="text-[#D98BAF]" data-id="element-366">LIBRE</strong> y manejar tus
    tiempos, inclusive viajando
  </>, <>
    Ahorrar tiempo y dinero con un método que realmente{' '}
    <strong className="text-[#D98BAF]" data-id="element-367">FUNCIONA</strong>
  </>, <>Que tu cuenta bancaria se vea así todos los meses 👇🏻</>];
export function ProofSection() {
  return <section className="px-6 py-8 flex flex-col items-center text-center max-w-7xl mx-auto pt-[0px] pb-[0px]" data-id="element-368">
      <p className="font-serif italic font-bold text-2xl md:text-3xl text-brand-navy mb-6 max-w-2xl" data-id="element-369">
        Y si yo pude, vos también podés. Por eso creé:
      </p>

      {/* Luxury Container */}
      <div className="w-full max-w-5xl relative rounded-[2.5rem] p-[2px] bg-gradient-to-b from-[#D98BAF] via-brand-pinkDark/50 to-[#D98BAF]/20 shadow-[0_25px_60px_-15px_rgba(217,139,175,0.45)] mb-8" data-id="element-370">
        <div className="bg-brand-navy rounded-[2.4rem] px-6 pt-10 pb-12 md:px-12 md:pt-12 md:pb-16 relative overflow-hidden flex flex-col items-center" data-id="element-371">
          {/* Ambient neon glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#D98BAF]/15 blur-[140px] rounded-full pointer-events-none" data-id="element-372" />

          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-373">
            <Sparkles size={16} strokeWidth={2.5} data-id="element-374" />
            El método definitivo
          </div>

          <h2 className="neon-title font-black text-[40px] md:text-[72px] leading-[1.05] tracking-tight uppercase mb-14" style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 900
        }} data-id="element-375">
            Fórmula UGC
          </h2>

          {/* Product mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative w-full max-w-4xl mb-16 z-10" data-id="element-376">
            <div className="absolute -inset-4 bg-gradient-to-tr from-[#D98BAF]/30 via-transparent to-[#D98BAF]/30 blur-2xl rounded-full opacity-50" data-id="element-377"></div>
            <img src="https://cdn.magicpatterns.com/uploads/xcxk8iFKHhPrqBcr1je2uU/pasted-image.png" alt="Programa Fórmula UGC en computadora y celular" loading="lazy" decoding="async" className="w-full h-auto relative z-10 drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)] hover:scale-[1.02] transition-transform duration-500" data-id="element-378" />
          </motion.div>

          <h3 className="font-serif font-bold text-2xl md:text-4xl text-white leading-tight max-w-3xl relative z-10 mt-[10px] mb-[10px]" data-id="element-379">
            Este Programa es exactamente para vos si querés...
          </h3>

          <ul className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto relative z-10 mb-10" data-id="element-380">
            {benefits.map((item, i) => <li key={i} className="flex items-start gap-4 bg-white/[0.03] border border-white/10 rounded-2xl p-6 text-left backdrop-blur-sm hover:border-[#D98BAF]/40 transition-colors" data-id="element-381">
                <div className="w-8 h-8 shrink-0 rounded-full bg-[#D98BAF]/20 flex items-center justify-center border border-[#D98BAF]/50 mt-0.5" data-id="element-382">
                  <Check size={18} strokeWidth={3} className="text-[#D98BAF]" data-id="element-383" />
                </div>
                <span className="text-white/90 text-[16px] md:text-[18px] leading-relaxed font-medium" data-id="element-384">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      {/* Mercado Pago balance - Premium Frame */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-3xl relative -mt-24 z-20" data-id="element-385">
        <div className="absolute -inset-2 bg-gradient-to-r from-emerald-400 via-emerald-300 to-emerald-500 rounded-3xl blur-lg opacity-40" data-id="element-386"></div>
        <div className="relative bg-brand-navy p-2 rounded-3xl border border-white/20 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)]" data-id="element-387">
          <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-lg z-10" data-id="element-388">
            <TrendingUp size={14} strokeWidth={3} data-id="element-389" />
            Resultados Reales
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/ra9e77iktzHG2Y82vKhv2z/pasted-image.jpg" alt="Saldo disponible en Mercado Pago" loading="lazy" decoding="async" className="w-full h-auto block rounded-2xl" data-id="element-390" />
        </div>
      </motion.div>
    </section>;
}